import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Sprout } from "lucide-react";
import { SITE } from "../../config/site";

export default function SiteFooter() {
  const [email, setEmail] = useState("");
  const [signedUp, setSignedUp] = useState(false);

  return (
    <footer className="bg-forest-900 text-canvas">
      <div className="container-fp grid gap-10 py-14 md:grid-cols-4">
        <div className="md:col-span-1">
          <div className="flex items-baseline gap-1.5">
            <span className="font-display text-2xl">Fancy</span>
            <span className="font-display text-2xl italic text-brass">Plants</span>
          </div>
          <p className="mt-3 max-w-xs text-sm text-canvas/70">
            Unusual, characterful plants chosen for the Irish climate — and packed to arrive
            healthy. A one-grower shop in the midlands.
          </p>
          {(SITE.social.instagram || SITE.social.facebook) && (
            <div className="mt-4 flex gap-3">
              {SITE.social.instagram && (
                <a href={SITE.social.instagram} aria-label="Instagram" target="_blank" rel="noreferrer" className="text-canvas/70 hover:text-brass">
                  <Instagram size={20} />
                </a>
              )}
              {SITE.social.facebook && (
                <a href={SITE.social.facebook} aria-label="Facebook" target="_blank" rel="noreferrer" className="text-canvas/70 hover:text-brass">
                  <Facebook size={20} />
                </a>
              )}
            </div>
          )}
          <div className="mt-4 space-y-1 text-sm text-canvas/70">
            <a href={`mailto:${SITE.email}`} className="block hover:text-brass">{SITE.email}</a>
            {SITE.phone && (
              <a href={`tel:${SITE.phone.replace(/[^\d+]/g, "")}`} className="block hover:text-brass">
                {SITE.phone}
              </a>
            )}
          </div>
        </div>

        <FooterCol
          title="Shop"
          links={[
            ["All plants", "/shop"],
            ["Pet-safe", "/shop?petSafe=1"],
            ["Hardy exotics", "/shop?category=Hardy%20Exotics"],
            ["Gift cards", "/gift-cards"],
          ]}
        />
        <FooterCol
          title="Learn"
          links={[
            ["Care Library", "/care"],
            ["Journal", "/journal"],
            ["About us", "/about"],
            ["Visit & delivery", "/visit"],
          ]}
        />

        <div>
          <h4 className="mb-3 font-display text-lg">The seasonal note</h4>
          <p className="mb-3 text-sm text-canvas/70">
            What's thriving this month, plus care tips for the Irish weather. No spam.
          </p>
          {signedUp ? (
            <p className="flex items-center gap-2 text-sm text-brass">
              <Sprout size={16} /> You're on the list — talk soon.
            </p>
          ) : (
            <form
              onSubmit={(e) => {
                e.preventDefault();
                if (email) setSignedUp(true);
              }}
              className="flex flex-col gap-2"
            >
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@email.ie"
                className="rounded-full border border-canvas/20 bg-canvas/5 px-4 py-2.5 text-sm text-canvas placeholder:text-canvas/40 focus:border-brass"
              />
              <button type="submit" className="btn-brass">
                Subscribe
              </button>
            </form>
          )}
        </div>
      </div>

      <div className="border-t border-canvas/10">
        <div className="container-fp flex flex-col items-center justify-between gap-3 py-5 text-xs text-canvas/60 sm:flex-row">
          <p>© {new Date().getFullYear()} Fancy Plants. Grown &amp; packed in the Irish midlands.</p>
          <div className="flex gap-4">
            <Link to="/privacy-policy" className="hover:text-canvas">Privacy</Link>
            <Link to="/terms-of-service" className="hover:text-canvas">Terms</Link>
            <Link to="/cookies-notice" className="hover:text-canvas">Cookies</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, links }) {
  return (
    <div>
      <h4 className="mb-3 font-display text-lg">{title}</h4>
      <ul className="space-y-2 text-sm">
        {links.map(([label, to]) => (
          <li key={label}>
            <Link to={to} className="text-canvas/70 hover:text-brass">
              {label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
